import React from 'react'
import { FormattedMessage } from 'react-intl'

import KledoLoader from 'components/UI/KledoLoader'

import styles from './style.module.scss'

const AppLoading = () => {
  return (
    <div className={styles.container}>
      <KledoLoader size={48} className={styles.spinner} />
      <h2 className={styles.title}>
        <FormattedMessage id="app.loading.title" />
      </h2>
      <p className={styles.description}>
        <FormattedMessage id="app.loading.description" />
      </p>
    </div>
  )
}

export default AppLoading
